import { Component, Inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { PromoProductFamily } from 'src/app/assabil-sales/models/entities/promo-product-family.entity';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'promo-product-family-lov',
    templateUrl: './promo-product-family-lov.component.html',
    styleUrls: ['./promo-product-family-lov.component.scss']
})

export class PromoProductFamilyLovComponent extends GenericLovComponent {

  codeFilter            : string;
  nameFilter            : string;
  
  columns = [
    { prop: 'promoProductFamilyCode',        name: 'Code',   insertOnly :  true },
    { prop: 'name',                          name: 'Nom'    },
    { prop: 'rank',                          name: 'Rang',   type : 'number'},
    ]

    promoProductFamilys  : PromoProductFamily[] = [];
    returnList           : boolean = false;

    constructor(
      public dialogRef: MatDialogRef<PromoProductFamilyLovComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,
      protected promoService  : PromoService,
      protected toastr        : ToastrService,
      protected router        : Router,
      protected location      : Location) {
        super();
        if (data) {
          this.promoProductFamilys  = data.promoProductFamilys;
          this.returnList           = data.returnList;
        }
      }

    //----------------------------------------------------------------------------------------------------------------
    loadData() {
      this.promoService.promoProductFamiliesGet(this.codeFilter, this.nameFilter).then(result => {
          this.promoProductFamilys = result;
        });
    }
    //----------------------------------------------------------------------------------------------------------------

    
    //----------------------------------------------------------------------------------------------------------------
    closeModal(promoProductFamily : PromoProductFamily){
      if (this.returnList) {
        let result = {promoProductFamilys : null, promoProductFamily : null};
        result.promoProductFamily  = promoProductFamily;
        result.promoProductFamilys = this.promoProductFamilys;
        this.dialogRef.close(result)
      } else {
        this.dialogRef.close(promoProductFamily)
      }
    }
    //----------------------------------------------------------------------------------------------------------------

}
